import { Component, OnInit } from '@angular/core';
import { piIconBlackhatLaptopBold } from '@predictiveindex/pi-client-icons';
import { IDropDownItem } from '@predictiveindex/tapestry';
import { PI } from '../../../constants-types';
import { TranslationService } from '../../../translations';
import { GlobalNavMenuActions, GlobalNavService } from '../global-nav.service';

@Component({
    selector: 'developer-dropdown',
    templateUrl: './developer-dropdown.component.html',
    standalone: false
})
export class DeveloperDropdownComponent implements OnInit {
    developerDropDownItems: IDropDownItem[];
    menuIcon = piIconBlackhatLaptopBold;
    isPendoEnabled = PI.appSettings.pendoOn;

    constructor(
        public TR: TranslationService,
        public nav: GlobalNavService
    ) {}

    ngOnInit(): void {
        this.buildDropDownItems();
    }

    buildDropDownItems(): void {
        this.developerDropDownItems = [
            {
                title: this.TR.key('translation.selectTranslationMode'),
                children: this.nav.getTranslationMenuItems(),
                id: 'selectTranslationMode',
                icon: 'translate_bold'
            },
            {
                title: this.nav.getPendoKey(),
                id: GlobalNavMenuActions.Pendo,
                icon: 'pendo'
            },
            {
                title: this.TR.key('globalnav.tapestry.guide'),
                id: GlobalNavMenuActions.Tapestry,
                icon: 'computer_guide_bold'
            },
            {
                title: this.TR.key('globalnav.tapestry.playground'),
                id: GlobalNavMenuActions.TapestryPlayground,
                icon: 'playground_bold'
            }
        ];
    }
}
